var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-content-loader user-select-none"},[_vm._l((_vm.lineLengths),function(lineLength){return [_c('div',{staticClass:"loader my-1"},[_vm._l((lineLength),function(n){return [_vm._v(" ")]})],2)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }